import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloud: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cloud"} maskId="square-filled-radius-0-stroke-1-IconCloud"><path d="M12 4C9.14244 4 6.68589 5.71209 5.59811 8.16478C2.96064 8.7963 1 11.1687 1 14C1 17.3137 3.68629 20 7 20H18C20.7614 20 23 17.7614 23 15C23 12.5602 21.2528 10.529 18.9412 10.0885C18.4942 6.65296 15.5571 4 12 4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCloud;
